<template>
  <div class="mt-10">
    <div class="container">
      <b-card>
        <div class="text-dark">
          <b-row class=" justify-content-center">
            <b-col md="4">
              <div>
                <h5>Estas comprando</h5>
                <hr/>
                <div>
                  <b-card no-body class="overflow-hidden">
                    <b-row no-gutters>
                      <b-col md="12">
                        <b-card-img :src="CourseInfo.cover" height="100%"></b-card-img>
                      </b-col>
                    </b-row>
                    <b-row no-gutters>
                      <b-col>
                        <b-card-body>
                          <h5>{{CourseInfo.title}}</h5>
                          <b-card-text>
                            <small>{{CourseInfo.description.substring(0, 100)}}...</small>
                          </b-card-text>
                          <h4 v-if="CourseInfo.price_val == 'Si'">{{CourseInfo.price | moneda}} <b-badge v-if="CourseInfo.descuento != null && CourseInfo.descuento != 'null' && exh <= CourseInfo.fecha_descuento" variant="warning" >-{{CourseInfo.descuento}}% Descuento</b-badge></h4>
                          <h4 v-else>Gratis</h4> 
                          <template v-if="CourseInfo.price_val == 'No'">
                          <hr>
                          <b-button class="btn float-left shadow  ml-3 " style="background: #4e92ff; border-color: #4e92ff;"    v-b-tooltip.hover   title="Adquirir Curso" @click="agregarCurso()">
                              Adquirir Curso  <b-spinner v-if="loader" small label="Espere ..."></b-spinner>
                          </b-button>  
                          <br><br>
                          </template>
                        </b-card-body>
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
              </div>
            </b-col>
            <b-col v-if="CourseInfo.price_val == 'Si'">
              <div>
                <h5>Resumen de compra</h5>
                <hr/>
                <div>
                  <div class="mt-3" >
                    <b class="text-center" style="color:#143069;">Selecciona el métodos de pago</b> 
                    <hr>
                    <b-button block v-b-toggle.accordion-1 variant="light"  size="lg" style="background:#143069; color:#fff;">Tarjeta débito/crédito</b-button> 
                    <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="mt-3"> 
                      <hr>
                      <center>
                         <template v-if="pagado1 == 0">
                            <CreditCard 
                              type="course"
                              :pay_id="pay_id"
                              :course_id="CourseInfo.id"
                              :cost="CourseInfo.price_val == 'No' ? 0 :(CourseInfo.descuento != null && CourseInfo.descuento != 'null' && exh <= CourseInfo.fecha_descuento ?  CourseInfo.price - (CourseInfo.price *  CourseInfo.descuento / 100) : CourseInfo.price)"
                              :valida="CourseInfo.price_val" 
                              currency="MXN"
                            /> 
                         </template>
                         <template v-else>
                            <h4 style="color:#28a745;">¡Gracias!</h4>
                            <p style="color:#28a745;">Tu pago se ha realizado con éxito.</p>
                            <br>
                            <button  class="btn btn-block  shadow-sm b-green" @click="recargar()">
                              <span>OK</span>
                            </button>
                         </template>
                      </center>
                      <hr>
                    </b-collapse> 

                    <b-button block v-b-toggle.accordion-2 variant="light" class="mt-3"  size="lg" style="background:#0333a9; color:#fff;">PayPal</b-button> 
                    <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="mt-3"> 
                        <hr>
                        <center> 
                          <template v-if="pagado2 == 0">
                              <CheckoutPayment 
                                :course_id="CourseInfo.id"
                                :cost="CourseInfo.price_val == 'No' ? 0 :(CourseInfo.descuento != null && CourseInfo.descuento != 'null' &&  exh <= CourseInfo.fecha_descuento ?  CourseInfo.price - (CourseInfo.price *  CourseInfo.descuento / 100) : CourseInfo.price)"
                              ></CheckoutPayment>
                          </template>
                          <template v-else>
                              <h4 style="color:#28a745;">¡Gracias!</h4>
                              <p style="color:#28a745;">Tu pago se ha realizado con éxito.</p>
                              <br>
                              <button  class="btn btn-block  shadow-sm b-green" @click="recargar()">
                                <span>OK</span>
                              </button>
                          </template>
                        </center>
                            <hr>
                    </b-collapse>  

                   <b-button block v-b-toggle.accordion-3 variant="light" class="mt-3"  size="lg" style="background:#005aff; color:#fff;">Pagos con cheque, en efectivo o transferencia</b-button> 
                    <b-collapse id="accordion-3"  accordion="my-accordion" role="tabpanel" class="mt-3">  
                      <template v-if="pagado3 == 0">
                        <table class="table mt-4">
                              <thead>
                                <tr>
                                  <th scope="col">Número de cuenta</th>
                                  <th scope="col">CLABE interbancaria</th>
                                  <th scope="col">Nombre titular de la cuenta</th>
                                  <th scope="col">Banco</th>
                                </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="ban in bancos" :key="ban.id">
                                      <td>{{ban.number_account}}</td>
                                      <td>{{ban.clabe}}</td> 
                                      <td>{{ban.owner}}</td> 
                                      <td>{{ban.bank}}</td>  
                                  </tr> 
                              </tbody>
                          </table>
                        <hr>
                          <center>
                            <h4>
                              Pagar $ {{CourseInfo.price_val == 'No' ? 0 :(CourseInfo.descuento != null && CourseInfo.descuento != 'null' && exh <= CourseInfo.fecha_descuento ?  CourseInfo.price - (CourseInfo.price *  CourseInfo.descuento / 100) : CourseInfo.price)}} MXN
                            </h4>
                            <hr>
                            <b style="color:#143069;">
                              Si ya realizaste el depósito o transferencia, por favor, anexa tu comprobante aquí, <br> una vez que hayamos comprobado el registro de tu pago en cuenta, se activará el curso.
                            </b>
                          </center>
                          <b-form @submit="this.onSubmit" class="mt-3">
                            <div class="row justify-content-center">
                              <div class="col-md-8">
                                <label class="d-block bh-cursor border-1 border-dashed p-4 border-gray-dark text-center font-gray-dark">
                                  <i class="fas fa-paperclip" v-show="!form.file"></i>
                                  <i class="fas fa-check-circle" v-show="form.file"></i>
                                  {{form.file ? form.file.name : 'Adjuntar documento '}}
                                  <input type="file" @change="handleFileUpload" hidden>
                                  <b-form-invalid-feedback :state="false" v-if="this.errors.file">
                                    Debe adjunta un PDF o imagen que valide tu conocimiento en este software.
                                  </b-form-invalid-feedback>
                                </label> 
                              </div>
                              <div class="col-md-12"></div>
                              <div class="col-md-4">
                                <b-button type="submit" class="b-orange col-md-12  mt-4" :disabled="loading">
                                  <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
                                  Enviar
                                </b-button>
                              </div>
                            </div>
                          </b-form>
                       </template>
                       <template v-else>
                        <hr>
                         <center>
                              <h4 style="color:#28a745;">¡Gracias!</h4>
                              <p style="color:#28a745;">Se ha enviado un comprobante de pago. <br> Una vez autorizado se dará acceso al curso.</p>
                              <br>
                              <button  class="btn btn-block  shadow-sm b-green" @click="recargar()">
                                <span>OK</span>
                              </button>
                         </center>
                       </template>
                      <hr>
                    </b-collapse>  
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  var numberFormat = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2
  });

import moment from "moment" 
import CheckoutPayment from '../payments/CheckoutPayment.vue'
  export default {
    components:{
        CheckoutPayment
    },
    data() {
      return {
        pay_id: new Date().valueOf(),
        ViewNewMethod: false,
        paymentMethods: [],
        methodSelected: null,
        CourseInfo: {},
        exh:moment().format("YYYY-MM-DD"),
        credentials: {
          sandbox: 'AQsJmBtplxhlv0ioa70wXAb9xNguw_VaCOuM1UagSGlP_i5CDhbk1MVz6VVBd_ExVC6CWzSPDqQN4oEU' 
        },
        myStyle: { 
          label: 'checkout',
          size:  'medium',
          shape: 'rect',
          color: 'gold'
        },
        bancos:[],
        form: { 
          file: ''
        },
        loading:false,
        errors:{},
        pagado1:0,
        pagado2:0,
        pagado3:0,
      };
    },
    created() {

      if (this.$route.params.CourseInfo) {
        this.CourseInfo = this.$route.params.CourseInfo;
        this.bancos = this.$route.params.Bancos;
        this.CourseInfo.course_payment ? this.$router.back() : false;
      } else {
        this.$router.back();
      }
    },
    mounted() {
      this.bus.$on("payment_" + this.pay_id, (result) => {
          // this.$router.back();
          this.pagado1 = 1;
      });

      this.bus.$on("payment_paypal", () => {
          // this.$router.back();
          this.pagado2 = 1;
      });
    },
    methods: {
      recargar(){
         location.href = "https://dev.kllaar.com/ver/curso/" + this.CourseInfo.url_public;
      },
      agregarCurso(){
        this.loader = true;
         this.api.post('course/payment-free/' + this.CourseInfo.id).then(({data}) => {
          console.log(data)
          this.loader = false;
          location.href = "https://dev.kllaar.com/ver/curso/" + this.CourseInfo.url_public;
        }).catch(err => {
           this.loader = false;
          swal("Error", "Ocurrio un error desconocido", "error")  
        })   
      },
      handleFileUpload(e) {
        this.form.file = e.target.files[0]
      },
      onSubmit(evt) { 
        event.preventDefault()
        let fd = new FormData()
        this.loading = true 
        fd.append('file', this.form.file)
        fd.append('course_id', this.CourseInfo.id)

        if (this.form.file === '') {
          this.errors.file = {};
          this.loading = false
          return false;
        }

        this.api.post('course/payment-efectivo', fd).then(({data}) => { 
          this.loading = false 
          this.form = { 
            file: ''
          };
          // swal("Correcto", "Se ha enviado exitosamente tu comprobante", "success")
          // location.reload()
          this.pagado3 = 1;
        }).catch(err => {
          this.loading = false
          if (err.response.status == 422) {
            this.errors = err.response.data.errors
          }
        })
     },
     pagarPaypal(){
       let fd = new FormData()  
        fd.append('course_id', this.CourseInfo.id)

        this.api.post('course/payment-efectivo', fd).then(({data}) => {   
          // location.reload()
          console.log(data);
        }).catch(err => {
          this.loading = false
          if (err.response.status == 422) {
            this.errors = err.response.data.errors
          }
        })
     }
    },
    filters: {
      moneda(val) {
        return numberFormat.format(val);
      }
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/#public/curse/PayCourse.vue